export const relations = [
  {
    name: 'elementAttributeType',
    relatedKey: 'id',
    relatedParentKey: 'elementAttributeTypeId',
  },
];

export const relatedParentKey = 'elementTypeId';
